import { render, staticRenderFns } from "./CostBill.vue?vue&type=template&id=53f672a4&scoped=true&"
import script from "./CostBill.vue?vue&type=script&lang=js&"
export * from "./CostBill.vue?vue&type=script&lang=js&"
import style0 from "./CostBill.vue?vue&type=style&index=0&id=53f672a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f672a4",
  null
  
)

component.options.__file = "CostBill.vue"
export default component.exports